var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"logo-banner-box"},[_c('MainHeaderLogin'),_c('MainHeaderLogo'),_c('MainHeaderBanner')],1),_c('div',{staticClass:"nav-bar-box"},[_c('MainHeaderNavBar')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }